import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import Dashboard from '../components/Dashboard';

const mapDispatchers = dispatch => {
  return {
    onAddPlayer: () => dispatch(push('/players/new')),
    //onGameDetails: gameID => dispatch(push(`/games/${gameID}/details`)),
    //onPlayerDetails: playerID => dispatch(push(`/players/${playerID}/details`)),
    onStartCoding: gameId => dispatch(push(`/games/${gameId}/code`))
  };
};

const mapStateToProps = state => {
  const games = playerKey =>
    state
      .getIn(['games', 'entities'])
      .filter(g => g.get('player') === playerKey);
  const players = state
    .getIn(['players', 'entities'])
    .sortBy(x => x.get('name'))
    .map((player, key) => player.set('games', games(key)));

  return {
    loading:
      state.getIn(['players', 'ui', 'loading'], false) ||
      state.getIn(['games', 'ui', 'loading'], false),
    players: players
  };
};

export default connect(mapStateToProps, mapDispatchers)(Dashboard);



// WEBPACK FOOTER //
// ./src/routes/home/containers/DashboardContainer.js